const POCartType = {
  SET_ADD_PO_CART: "SET_ADD_PO_CART",
  SET_PO_CART_LIST: "SET_PO_CART_LIST",
  UPDATE_PO_CART_PRODUCT: "UPDATE_PO_CART_PRODUCT",
  DELETE_PO_CART_PRODUCT: "DELETE_PO_CART_PRODUCT",
  CART_LIST: "CART_LIST",
};

export interface AddPoCart {
  seller_id: number;
  vendor_id: number;
  po_date: any;
  ref_no: number;
  product_id: number;
  product_name: string;
  product_code: number;
  mrp: any;
  landing_cost: any;
  po_qty: number;
  tax: number;
}

export interface GetPoCartList {
  limit: number;
  page: number;
  vendor_id: number;
}

export interface UpdatePoCartProduct {
  id: number;
  action: string;
  qty: number;
}

export interface DeletePoCartProduct {
  id: number;
}

export default POCartType;
